import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 4H4v13a2 2 0 01-2-2V4a2 2 0 012-2h11a2 2 0 012 2H6zm3 5h11v11H9V9zM7 9a2 2 0 012-2h11a2 2 0 012 2v11a2 2 0 01-2 2H9a2 2 0 01-2-2V9z" }));
export default createSvgIcon(iconPath, "Copy");
//# sourceMappingURL=CopyIcon.js.map